<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'DialogCloseButton',
  props: {
    closeMethod: {
      type: Function,
      required: true
    }
  }
})
</script>

<template>
  <button type="button" class="dialog-close-btn" @click="closeMethod()">
    <v-icon icon="mdi-close" size="20" />
  </button>
</template>

<style scoped>
.dialog-close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
}
</style>
